import { alias, createModelSchema, identifier, reference } from "serializr";
import { Cloneable } from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class TaskTimeType extends Cloneable {
    static DURATION = new TaskTimeType(0, "DURATION");
    static INTERVAL = new TaskTimeType(1, "INTERVAL");

    static _values = [
        this.DURATION,
        this.INTERVAL,
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TaskTimeType.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof TaskTimeType) {
            return TaskTimeType._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "DURATION") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof TaskTimeType) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TaskTimeType());
        } else if (target instanceof TaskTimeType) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TaskTimeType, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});
